import Vue from 'vue';
import Buefy from 'buefy';
import moment from 'moment';
import VueTrix from "vue-trix";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import draggable from 'vuedraggable';
import VueTreeList from 'vue-tree-list';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import Tree from 'vue-tree-list';
import axios from 'axios';
import CircularCounter from 'vue-circle-counter'
const numeral = require("numeral");
import { decode } from 'html-entities';
import { parse, stringify, toJSON, fromJSON } from 'flatted';
import Cleave from 'cleave.js'
/*import VueCharts from 'vue-chartjs'*/
import { Bar, Pie, Doughnut } from 'vue-chartjs/legacy'
/*import { ref } from 'vue' */

window.Vue = require('vue');
window.htmlEntity = require('html-entities');
window.moment = require('moment');
window.qs = require('qs');
window.axios = axios;
window.stringify = stringify;
window.parse = parse
window.numeral = numeral;
/*window.ref = ref;*/

Vue.prototype.$services = {
    'parties': require("./services/PartiesService").default,
    'annexes': require("./services/AnnexesService").default,
    'classificationHierarchies': require("./services/ClassificationHierarchiesService").default,
    'classificationSystemsService': require("./services/ClassificationSystemsService").default,
    'thresholds': require("./services/ThresholdsService").default,
    'entities': require("./services/EntitiesService").default,
    'notes': require("./services/NotesService").default,
    'goods': require("./services/GoodsService").default,
    'services': require("./services/ServicesService").default,
    'constructionServices': require("./services/ConstructionServicesService").default,
    'staticContents': require("./services/StaticContentsService").default,
    'procurementTypesService': require("./services/ProcurementTypesService").default,
    'publicationMediasService': require("./services/PublicationMediasService").default,
    'thresholdNotificationsService': require("./services/ThresholdNotificationsService").default,
    'nationalCurrencyThresholdsService': require("./services/NationalCurrencyThresholdsService").default,
    'users': require("./services/UsersService").default,
    'proposedModificationNotifications': require("./services/ProposedModificationNotificationsService").default,
    'legalBasis': require("./services/LegalBasisService").default,
    'partyNotificationLanguages': require("./services/PartyNotificationLanguagesService").default,
    'notifications': require("./services/NotificationsService").default,
    'approvals': require("./services/ApprovalsService").default,
    'attachmentsService': require("./services/AttachmentsService").default,
    'dialectsService': require("./services/DialectsService").default,
    'attachmentTypesService': require("./services/AttachmentTypesService").default,
    'objectionNotificationService': require("./services/ObjectionNotificationsService").default,
    'documentsService': require("./services/DocumentsService").default,
    'withdrawalOfProposedModificationNotificationService': require("./services/WithdrawalOfProposedModificationNotificationsService").default,
    'withdrawalOfObjectionNotificationService': require("./services/WithdrawalOfObjectionNotificationsService").default,
    'implementationNotificationService': require("./services/ImplementationNotificationService").default,
    'modification': require("./services/ModificationsService").default,
    'entityMetadatas': require("./services/EntityMetadatasService").default,
    'noteMetadatas': require("./services/NoteMetadatasService").default,
    'noteItemMetadatas': require("./services/NoteItemMetadatasService").default,
    'noteItems': require("./services/NoteItemsService").default,
    'goodMetadatas': require("./services/GoodMetadatasService").default,
    'goodItemMetadatas': require("./services/GoodItemMetadatasService").default,
    'goodItems': require("./services/GoodItemsService").default,
    'serviceMetadatas': require("./services/ServiceMetadatasService").default,
    'serviceItemMetadatas': require("./services/ServiceItemMetadatasService").default,
    'serviceItems': require("./services/ServiceItemsService").default,
    'constructionServiceMetadatas': require("./services/ConstructionServiceMetadatasService").default,
    'constructionServiceItemMetadatas': require("./services/ConstructionServiceItemMetadatasService").default,
    'constructionServiceItems': require("./services/ConstructionServiceItemsService").default,
    'publicationMediaNotificationsService': require("./services/PublicationMediaNotificationsService").default,
    'statisticsNotificationsService': require("./services/StatisticsNotificationsService").default,
    'nationalLegislationNotificationsService': require("./services/NationalLegislationNotificationsService").default,
    'additionalInfoNotificationsService': require("./services/AdditionalInfoNotificationsService").default,
    'arbitrationNotificationsService': require("./services/ArbitrationNotificationsService").default,
    'letDocumentNotificationsService': require("./services/LetDocumentNotificationsService").default,
    'partyClassificationSystemsService': require("./services/PartyClassificationSystemsService").default,
    'partyCoveragesService': require("./services/PartyCoveragesService").default,
    'coverages': require("./services/CoveragesService").default,
    'writtenExchangeNotificationsService': require("./services/WrittenExchangeNotificationsService").default,
    'statisticsClassificationSystemsService': require("./services/StatisticsClassificationSystemsService").default,
    'withdrawalArbitrationNotificationsService': require("./services/WithdrawalArbitrationNotificationsService").default,
    'notificationTypeService': require("./services/NotificationTypeService").default,
    'appendices': require("./services/AppendicesService").default,
    'notificationFormats': require("./services/NotificationFormatsService").default,
    'symbols': require("./services/SymbolsService").default,
    'notificationPortal': require("./services/NotificationPortalService").default,
    'withdrawalEquivalentCoverageNotificationsService': require("./services/WithdrawalEquivalentCoverageNotificationsService").default,
    'currenciesService': require("./services/CurrenciesService").default,
    'partyCurrenciesService': require("./services/PartyCurrenciesService").default,
    'emailTemplates': require("./services/EmailTemplatesService").default,

    'reportingBasis': require("./services/ReportingBasisService").default,
    'reportingPeriodTypes': require("./services/ReportingPeriodTypesService").default,
    'statistics': require("./services/StatisticsService").default,
}

Vue.use(Buefy, {
    defaultIconPack: 'fas',
    defaultContainerElement: '#app',
    defaultLocale: 'en_GB',
    defaultDateFormatter: date => date.toLocaleDateString('en-GB')
    // ... https://buefy.org/documentation/constructor-options
})

Vue.use(VueTrix);
Vue.use(VueTreeList)
Vue.use(CKEditor)
Vue.use(Tree)
/*Vue.use(VueCharts)*/
Vue.use(Bar)
Vue.use(Pie)
Vue.use(Doughnut)
//Vue.use(Line)

Vue.component('circle-counter', CircularCounter);
Vue.component('bar', Bar);
Vue.component('pie', Pie);
Vue.component('doughnut', Doughnut);
/*Vue.component('chart',Chart);*/
/*ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)*/
Vue.component('tree-select', Treeselect);
Vue.component('draggable', draggable);

Vue.filter('decodeHTMLEntity', function (value) {
    if (value) {
        return decode(value);
    }
});
Vue.filter('dateFilter', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});
Vue.filter('dateTimeFilter', function (value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY hh:mm:ss')
    }
});
Vue.filter('dateFilterMedium', function (value) {
    if (value) {
        moment.locale(window.currentLanguage);
        return moment(String(value)).format('D MMMM YYYY')
    }
});
Vue.filter('dateFilterLong', function (value) {
    if (value) {
        moment.locale(window.currentLanguage);
        return moment(String(value)).format('dddd, D MMMM YYYY')
    }
});
Vue.filter("thresholdValue", function (value) {
    return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
});
Vue.filter("isNumeric", function (value) {
    return numeral(new Intl.NumberFormat('en-US').format(value)).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
});
Vue.filter("exchangeRateValue", function (value) {
    return numeral(value).format("0,0.000"); // displaying other groupings/separators is possible, look at the docs
});
Vue.filter('stripParagraphTags', function (value) {
    if (value) {
        return value.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "");;

    }
});

Vue.filter('decodeHTMLEntity', function (value) {
    if (value) {
        return decode(value);
    }
});
Vue.filter('stringFormat', function (value, replacement) {
    if (value) {
        return value.replace('{0}', replacement);
    }
});
Vue.directive('cleave', {
    bind(el, binding) {
        const input = el.querySelector('input')
        input._vCleave = new Cleave(input, binding.value)
    },
    unbind(el) {
        const input = el.querySelector('input')
        input._vCleave.destroy()
    }
});

Vue.mixin({
    methods: {
        cleaveOnInput: function (event, model, main, masked) {

           

            model[masked] = event.target._vCleave.getFormattedValue();
            model[main] = event.target._vCleave.getRawValue()
        }
    }
});
require('./components/component-loader');
// import ComponentLoader from './components/component-loader';
// ComponentLoader.loadComponents();
//
//

